export default {
    root: {
        borderRadius: 0
    }
}